export const getLocationObj = (state) => state.newFilters.LocationObj;
export const getAgencyOptions = (state) => state.newFilters.agencyObj;
export const getUsersOptions = (state) => state.newFilters.userObj;
export const getRetailerCorporationOptions = (state) => state.newFilters.corpObj;
export const getCampaignsOptions = (state) => state.newFilters.campaignsObj;
